import { forwardRef, type Ref, type SVGProps } from "react";
const IconCameraShutterFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m16.41 11-4.64-8.35A14 14 0 0 0 2.94 11Z" />
    <path d="M19.58 19h10.09a14 14 0 0 0 .33-3 13.92 13.92 0 0 0-3.15-8.84Z" />
    <path d="m20.34 13.94 5.08-8.28A14 14 0 0 0 16 2a14.5 14.5 0 0 0-2.2.19Z" />
    <path d="m15.12 21 4.72 8.45A14 14 0 0 0 29.06 21Z" />
    <path d="m11 17.68-5 8.06A13.9 13.9 0 0 0 16 30a13 13 0 0 0 1.78-.13Z" />
    <path d="M11.54 13H2.33A14 14 0 0 0 2 16a13.9 13.9 0 0 0 2.61 8.12Z" />
  </svg>
);
const ForwardRef = forwardRef(IconCameraShutterFilledSVG);
ForwardRef.displayName = "IconCameraShutterFilled";
export { ForwardRef as IconCameraShutterFilled };
